<template>
  <b-card
    footer-tag="footer"
    class="Card"
    :img-src="`${image.filename}/m/500x450/smart`"
  >
    <b-card-text class="Card__text">
      {{ content }}
    </b-card-text>
    <template #footer>
      <b-button
        :href="buttonTo"
        class="Card__button"
        block
        :variant="buttonVariant"
      >
        {{ buttonTitle }}
      </b-button>
    </template>
  </b-card>
</template>

<script>
export default {
  props: {
    buttonVariant: {
      type   : String,
      default: '',
    },
    image  : { type: Object },
    content: {
      type    : String,
      required: true,
    },
    buttonTitle: {
      type    : String,
      required: true,
    },
    buttonTo: {
      type    : String,
      required: true,
    },
  },
  data () {
    return { setBackgroundImage: { backgroundImage: `url(${this.image})` } }
  },
}
</script>

<style lang="scss" scoped>
</style>
